export default "__VITE_ASSET__79c52874__"